import { APIS } from 'common/constants/endpoints';
import { Config } from '@oscar/request';
import { searchingSteelNotification, searchingNotification } from './data';

export { default as ScaffoldDetail } from './ScaffoldDetail';
export { default as WorkDetail } from './WorkDetail';
export { default as ProposalDetail } from './ProposalDetail';
export { default as FinalHandOver } from './FinalHandOver';
export { default as PTW } from './PTW';
export { default as InsulationDetail } from './InsulationDetail';
export { default as RequestorDetail } from './RequestorDetail';
export { default as PaintingWorkDetail } from './PaintingWorkDetail';
export { default as QaqcDetail } from './QaqcDetail';
export { default as PaintingDetail } from './PaintingDetail';
export { default as WorkFlow } from './WorkFlow';
export { default as PaintingButtons } from './PaintingButtons';
export { default as ActivityLog } from './ActivityLog';

Config.getInstance().addMockRequests([
  {
    name: 'attachments',
    url: APIS.UPLOADED_FILE,
    method: 'POST',
    mockData: config => {
      const formData = config?.data as FormData;
      const result: any[] = [];
      formData.forEach(value => {
        if (value instanceof File) {
          const newObject = {
            lastModified: value.lastModified,
            name: value.name,
            size: value.size,
            type: value.type,
            id: new Date().getTime(),
          };
          result.push(newObject);
        }
      });
      return {
        data: result,
      };
    },
  },
]);
